import { useTheme } from "@emotion/react";
import { Box, Button, Card, Grid, Modal, useMediaQuery } from "@mui/material";
import { ButtonText, H3, H5, H6 } from "components/Typography";
import AppTextField from "components/input-fields/AppTextField";
import { useState } from "react";

import { X } from "react-feather";

export default function AddAPIModal({ showModal, setShowModal }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  const [name, setName] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [homepage, setHomepage] = useState("");

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : isTablet ? "600px" : "600px",
    maxHeight: "90vh",
    overflowY: "auto",
    backgroundColor: theme.palette.primary.white,
    border: "none",
    boxShadow: 24,
    outline: "none",
    paddingRight: "30px",
    paddingLeft: "30px",
    scrollbarWidth: "thin",
    borderRadius: 6,
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
    },
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Modal
        open={showModal}
        onClose={handleClose}
        disableEnforceFocus={true}
        disableBackdropClick={false}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          backdropFilter: "blur(5px)",
          backgroundColor: "transparent",
          outline: "none",
        }}
      >
        <Card sx={modalStyle}>
          <Grid py={4}>
            <Box
              sx={{
                flexDirection: "row",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <H3>API 추가</H3>
              <Box
                onClick={() => handleClose()}
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: theme.palette.borderColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 100,
                  cursor: "pointer",
                  position: "absolute",
                  right: "32px",
                }}
              >
                <X color={theme.palette.grey400} />
              </Box>
            </Box>
            {/* Content */}

            <Box
              pt={1}
              pb={0}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container spacing={3} py={4} px={isMobile ? 0 : 0}>
                <Grid item xs={12}>
                  <H6 mb={1}>이름</H6>
                  <AppTextField
                    fullWidth
                    name="name"
                    placeholder="이름을 입력해 주세요"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{
                      backgroundColor:
                        theme.palette.primary.lightBlueBackground,
                      "& .MuiOutlinedInput-input::placeholder": {
                        fontWeight: 300,
                        fontSize: 15.5,
                        color: "#B5B7C0",
                      },
                    }}
                    inputProps={{ style: { height: 18 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <H6 mb={1}>endpoint</H6>
                  <AppTextField
                    fullWidth
                    name="endpoint"
                    placeholder="endpoint를 입력해 주세요"
                    value={endpoint}
                    onChange={(e) => setEndpoint(e.target.value)}
                    sx={{
                      backgroundColor:
                        theme.palette.primary.lightBlueBackground,
                      "& .MuiOutlinedInput-input::placeholder": {
                        fontWeight: 300,
                        fontSize: 15.5,
                        color: "#B5B7C0",
                      },
                    }}
                    inputProps={{ style: { height: 18 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <H6 mb={1}>홈페이지 링크</H6>
                  <AppTextField
                    fullWidth
                    name="homepage"
                    placeholder="홈페이지 링크를 입력해 주세요"
                    value={homepage}
                    onChange={(e) => setHomepage(e.target.value)}
                    sx={{
                      backgroundColor:
                        theme.palette.primary.lightBlueBackground,
                      "& .MuiOutlinedInput-input::placeholder": {
                        fontWeight: 300,
                        fontSize: 15.5,
                        color: "#B5B7C0",
                      },
                    }}
                    inputProps={{ style: { height: 18 } }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    sx={{
                      width: "100%",
                      height: "48px",
                      backgroundColor: theme.palette.primary.darkBlue,
                      borderRadius: 2,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.darkBlueHover,
                      },
                    }}
                  >
                    <ButtonText>추가</ButtonText>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Card>
      </Modal>
    </>
  );
}
